module.exports = __webpack_public_path__ + "images/help/icon-twr60-ca990a72905ef69792c2c8fde54d6ba0.png";